import { render, staticRenderFns } from "./DashboardBalanceSwap.vue?vue&type=template&id=4d56bdd4&"
import script from "./DashboardBalanceSwap.vue?vue&type=script&lang=js&"
export * from "./DashboardBalanceSwap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports